import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import path from 'ramda/src/path'

export default (state) => {
	const recordId = currentRouteParamsRecordId(state)
	return path(['api', 'records', 'project', recordId, 'platform'], state)
}
